<script>
    import Vue from 'vue'
    import CompanyDetailCarousel from './CompanyDetailCarousel'
    import PhotoGallery from './PhotoGallery'
    import CompanyCourseCard from './CompanyCourseCard'
    import CompanySummerCampCard from './CompanySummerCampCard'
    import CompanyEventCard from "./CompanyEventCard"
    import CompanyOrangopackCard from './CompanyOrangopackCard'
    import CompanyTakingChargeModal from './CompanyTakingChargeModal'
    import {Form} from '../../helpers/Form/Form'
    import {Gtag} from '../../mixins/ga'

    export default {
        mixins: [Gtag],
        name: "Detail",
        components: {
            CompanyTakingChargeModal,
            CompanyOrangopackCard,
            CompanyDetailCarousel,
            CompanyCourseCard,
            CompanySummerCampCard,
            CompanyEventCard,
            PhotoGallery
        },
        props: {
            company: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                geoerrormessage: null,
                fetching: false,
                showMapFullscren: false,
                contact: {
                    recaptcha: null,
                    email: null,
                    message: null
                },
                form: new Form({
                    sport: '',
                    id: Math.random(),
                    latitude: 0,
                    longitude: 0,
                    page: 1,
                    promoted: 'none',
                    company: this.company.id,
                    search_type: 'courses',
                    per_page: 9,
                    with: [],
                    from: moment().format('YYYY-MM-DD')
                }),
                selectedTab: 'courses',
                totalHiddenSports: 0,
                selectedSport: null,
                showSportDetails: false,
                showAllSports: false,
                filters: {},
                results: {
                    courses: {
                        pagination: {},
                        data: []
                    },
                    events: {
                        pagination: {},
                        data: []
                    },
                    summer_camps: {
                        pagination: {},
                        data: []
                    },
                },
                ages: [],
                incomingEvents: [],
                sports: [],
                images: [],
                ageList: [],
                contactForm: {},
                limitDesc: 350,
                descExpanded: false,
                owlMargin: 20,
                mobileDetect: window.innerWidth < 800,
            }
        },
        watch: {
            contact: {
                handler(val) {
                    this.checkRequiredFields(val)
                },
                deep: true
            },
            async selectedTab(value) {
                this.$set(this.form, 'sport', '')
                this.$set(this.form, 'page', 1)
                this.$set(this.form, 'search_type', value)
                
                if (this.results[value].data.length == 0) {
                    await this.fetchItemByTab(value)
                }
            }
        },
        async mounted() {
            $("#spinner-modal").modal()

            await this.getLocation(async () => {
                let hash = window.location.hash.substring(1)
                if (hash) {
                    if (hash !== 'courses' && hash !== 'events' && hash !== 'summer_camps') {
                        hash = 'courses'
                    }
                }

                if (!hash || hash === 'courses') {
                    await this.fetchItemByTab('courses')
                } else {
                    this.onSwitchTab(hash)
                }

                const vm = this
                $("#contactform input#recaptcha").on('change', function() {
                    vm.$set(vm.contact, 'recaptcha', $(this).val())
                })

                $("#contactform :input").on('change input copy keyup', function() {
                    let data = $(this).serializeArray()
                    for (let i in data) {
                        if (vm.contact.hasOwnProperty(data[i].name)) {
                            vm.$set(vm.contact, data[i].name, data[i].value)
                        }
                    }
                })

                $("#company-contact-form, #compant-full-map").modal({
                    show: false,
                    keyboard: false,
                    backdrop: 'static'
                })

                $("#company-contact-form").on('hidden.bs.modal', () => {
                    this.resetData()
                })

                await this.initPageEvents()

                window.onresize = () => {
                  console.log(window.innerWidth)
                  this.$set(this, 'mobileDetect', window.innerWidth < 800)
                }
            })
        },
        updated() {
            let hash = window.location.hash.substring(1)

            if (hash) {
                if (hash !== 'courses' && hash !== 'events' && hash !== 'summer_camps') {
                    hash = 'courses'
                }

                this.onSwitchTab(hash)

                $('html,body').animate({
                    scrollTop: $(".company-detail__additional").eq(2).offset().top-50
                })
            }
        },
        methods: {
            addToCart(buyable, type, course = null) {
                var self = this;

                axios({
                    method: 'post',
                    url: 'addToCart',
                    data: {
                        buyable: buyable,
                        type: type,
                        course
                    }
                }).then((response) => {                    
                    this.sendGaEvent(
                        'Acquista',
                        'Corsi',
                        '#aggiungi-carrello-corso'
                    )
                       
                    window.alerts.success('Elemento aggiunto al carrello');
                    self.federations = response.data.federations;

                    window.location = '/carts'
                }).catch((error) => {
                    self.message = 'Error';
                });
            },            
            resetData() {
                window.grecaptcha.reset()

                this.contact = {
                    email: null,
                    message: null,
                    recaptcha: null
                }
            },
            checkRequiredFields(val) {
                this.$set(this.contact, 'recaptcha', window.grecaptcha.getResponse())
            },
            setCompanyHeaderPosition() {
                let $companyBodyObj = $(".company-detail__header__practiced__container")

                if (window.isMobile()) {
                    let $headerObj = $(".company-detail__header")
                    let paddingTop = $headerObj.outerHeight(true) + 30

                    $companyBodyObj.attr('style', `padding-top: ${parseInt(paddingTop)}px`)
                } else {
                    let $addressObj = $(".company-detail__header .company-detail__additional__map__header")

                    let addressPos = $addressObj.offset().top
                    let addressHeight = $addressObj.outerHeight(true)
                    let bodyPosition = $companyBodyObj.offset().top

                    let fixTopPosition = (-1 * ((bodyPosition - addressPos) - addressHeight)) + 20

                    $companyBodyObj.attr('style', `padding-top: 0`)
                    $(".company-detail__header__practiced__container .company-detail__header__practiced").attr('style', `top: ${parseInt(fixTopPosition)}px`)
                }
            },
            async filterCourseBy(sport) {
                if (this.showAllSports) {
                    this.toggleModalSports()
                }

                this.onSwitchTab('courses')
                this.goTo('.anchor-tabs')

                this.$set(this.results.courses, 'pagination', Object.assign({}))
                this.$set(this.results.courses, 'data', [])
                this.$set(this.form, 'page', 1)
                this.$set(this.form, 'sport', sport === null ? '' : sport.name)
                
                await this.fetchItemByTab('courses');
            },
            onShowEventDetail(event) {
                location.href = route('event.show', event.slug)
            },
            onZoomIn() {
                this.$refs.modalMapRef.$mapObject.setZoom(
                    this.$refs.modalMapRef.$mapObject.getZoom() + 1
                );
            },
            onZoomOut() {
                this.$refs.modalMapRef.$mapObject.setZoom(
                    this.$refs.modalMapRef.$mapObject.getZoom() - 1
                );
            },
            onOpenGoogleMaps() {
                if (this.os == 'android') {
                    location.href = `geo:${this.company.latitude},${this.company.longitude}?q=${this.company.latitude},${this.company.longitude}(${this.company.address})?q=google`
                }
                if (this.os == 'ios') {
                    location.href = `http://maps.google.com/maps?saddr=${this.company.latitude},${this.company.longitude}`
                }
            },
            toggleMapFullScreen() {
                this.showMapFullscren = !this.showMapFullscren
            },
            goTo(target) {
                if (this.showSportDetails) {
                    this.toggleSportDetail()
                }
            },
            goOnTop() {
                $("html,body").animate({
                    scrollTop: 0
                }, 500)
            },
            async initPageEvents() {
                let slider_right = $('.owl-next').find('span');
                $(slider_right).empty();
                $(slider_right).append('<img src="/images/right-arrow.svg" alt="">');

                this.$refs.mapRef.$mapPromise.then((map) => {
                    map.set('navigationControl', false);
                    map.set('mapTypeControl', false);

                    $("#company-full-map").on('show.bs.modal', () => {
                        Vue.$gmapDefaultResizeBus.$emit('resize')
                    })
                });

                this.setCompanyHeaderPosition()

                if (window.isMobile()) {
                    this.$set(this, 'owlMargin', 10)
                    this.$set(this, 'limitDesc', 120)
                } else {
                    this.$set(this, 'owlMargin', 20)
                    this.$set(this, 'limitDesc', 350)
                }

                window.addEventListener('resize', (e) => {
                    let containerOffsetMobile = $(".company-detail__header__practiced__container .company-detail__header__practiced").position()
                    let containerOffsetDesktop = $(".company-detail__header__practiced__container .company-detail__header__practiced").offset()

                    this.setCompanyHeaderPosition()

                    if (window.isMobile()) {
                        this.$set(this, 'owlMargin', 10)
                        this.$set(this, 'limitDesc', 120)

                        $("#compant-full-map").modal('hide')

                        $(".sport-modal, .sport-detail__modal").css({
                            top: containerOffsetMobile.top,
                            left: containerOffsetMobile.left
                        })
                    } else {
                        this.$set(this, 'owlMargin', 20)
                        this.$set(this, 'limitDesc', 350)

                        $(".sport-modal, .sport-detail__modal").css({
                            top: containerOffsetMobile.top + $(".company-detail__header__practiced__container .company-detail__header__practiced").outerHeight(true) - 10,
                            left: containerOffsetDesktop.left
                        })
                    }
                })

                window.onscroll = () => {
                    let anchorOffset = $(".anchor-tabs").offset().top
                    let tabsOffset = $(".company-detail__tabs").offset().top
                    if (window.pageYOffset >= tabsOffset) {
                        $(".company-detail__tabs").addClass('sticky-tabs');
                    }
                    if (window.pageYOffset < anchorOffset) {
                        $(".company-detail__tabs").removeClass('sticky-tabs');
                    }
                }

                let containerOffsetMobile = $(".company-detail__header__practiced__container .company-detail__header__practiced").position()
                let containerOffsetDesktop = $(".company-detail__header__practiced__container .company-detail__header__practiced").offset()

                document.onreadystatechange = () => {
                    if (document.readyState == "complete") {
                        this.setListSportsContainer()

                        if (window.isMobile()) {
                            $(".sport-modal, .sport-detail__modal").css({
                                top: containerOffsetMobile.top,
                                left: containerOffsetMobile.left
                            })
                        } else {
                            $(".sport-modal, .sport-detail__modal").css({
                                top: containerOffsetMobile.top + $(".company-detail__header__practiced__container .company-detail__header__practiced").outerHeight(true) - 10,
                                left: containerOffsetDesktop.left
                            })
                        }
                    }
                }
            },
            async getLocation(after) {
                let methodAfter = this.returnPosition
                if (typeof after === 'function') {
                    methodAfter = async (position) => {
                        await this.returnPosition(position)
                        await after()
                    }
                }

                let methodErrorAfter = this.errorPosition
                if (typeof after === 'function') {
                    methodErrorAfter = async (error) => {
                        await this.errorPosition(error)
                        await after()
                    }
                }

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        methodAfter,
                        methodErrorAfter
                    );
                }
            },
            async returnPosition(position) {
                this.$set(this.form, 'latitude', position.coords.latitude * 1)
                this.$set(this.form, 'longitude', position.coords.longitude * 1)

                this.geoerrormessage = null

                await this.getCompanyDetail(position.coords)
            },
            async errorPosition(error) {
                let { latitude } = this.form
                if (_.isEmpty(latitude)) {
                    this.$set(this.form, 'latitude', 0)
                    this.$set(this.form, 'longitude', 0)

                    this.geoerrormessage = 'Attenzione: le distanze potrebbero non essere calcolate correttamente, in quanto non è stata attivata la geolocalizzazione'

                    await this.getCompanyDetail(this.form)
                }
            },
            async fetchItemByTab(tab) {
                if (! this.form.hasOwnProperty('promoted')) {
                    this.$set(this, 'form', new Form(Object.assign(this.form.data(), {
                        promoted: 'none'
                    })))
                }

                this.$set(this.form, 'with', [])
                this.$set(this.form, 'promoted', 'none')
                if (tab == 'summer_camps') {
                    delete this.form.promoted
                    this.$set(this.form, 'with', ['disabilities', 'sports'])
                }

                await this.fetchResults()
            },
            async fetchResults() {
                $("#spinner-modal").modal()

                this.form
                    .get(route('company.search_type'))
                    .then(response => {
                        if (response.data.length > 0) {
                            this.$set(this.results[this.selectedTab], 'pagination', _.omit(response, 'data'))
                            this.$set(
                                this.results[this.selectedTab],
                                'data',
                                this.results[this.selectedTab].data.concat(response.data))

                            this.$set(this.form, 'page', this.results[this.selectedTab].pagination.current_page + 1)
                        } else {
                            this.$set(this.form, 'page', 1)
                            this.$set(this.results[this.selectedTab], 'pagination', Object.assign({}))
                        }

                        $("#spinner-modal").modal('hide')
                    }).catch((error) => {
                        $("#spinner-modal").modal('hide')
                    })
            },
            onSwitchTab(tab) {
                this.$set(this, 'selectedTab', tab)

                let source = route('company.show', this.company.slug)
                window.history.pushState({ path: `${source}#${tab}` }, '', `${source}#${tab}`)

                if (window.isMobile()) {
                    $("html,body").animate({
                        scrollTop: $('.company-detail__tabs__tab-content').offset().top - 150
                    })
                }
            },
            isSelectedTab(tab) {
                return this.selectedTab === tab
            },
            setListSportsContainer() {
                let $container = $(".sport-lists__partials")
                let $children = $(".sport-lists__partials .company-detail__header__practiced__sport")
                let maxHeight = $container.outerHeight(true)
                let vm = this
                let offsetLists = []
                let totalHeight = 0

                this.totalHiddenSports = 0
                $children.removeClass('d-none')
                try {
                    $children.each(function() {
                        if (! offsetLists.includes($(this).offset().top)) {
                            offsetLists.push($(this).offset().top)
                            totalHeight += $(this).outerHeight(true)
                        }

                        if (totalHeight > maxHeight || vm.horizontallyBound($container, $(this))) {
                            $(this).addClass('d-none')
                            vm.totalHiddenSports++
                        }

                        if ($(this).hasClass('more-sport')) {
                            if (vm.totalHiddenSports > 0 && $(this).hasClass('d-none')) {
                                $(".company-detail__header__practiced__sport:not(.d-none)", $container).last().addClass('d-none')
                                $(this).removeClass('d-none')
                                vm.totalHiddenSport--
                            } else {
                                $(this).addClass('d-none')
                            }
                        }
                    })
                } catch (e) {
                    console.log('e', e)
                }
            },
            horizontallyBound($parentDiv, $childDiv) {
                var parentRect = $parentDiv[0].getBoundingClientRect();
                var childRect = $childDiv[0].getBoundingClientRect();
                return childRect.bottom >= parentRect.bottom || childRect.right >= parentRect.right
            },
            async getCompanyDetail({latitude, longitude}) {
                let source = route('companies.detail', this.company.id)
                let { data } = await axios.get(`${source}?latitude=${latitude}&longitude=${longitude}`)

                this.$set(this, 'ages', data.details['ages'])
                this.$set(this, 'sports', Object.values(data.details['tags']))
                this.$set(this, 'incomingEvents', data.incomingEvents)
            },
            toggleSportDetail(sport = null) {
                this.showSportDetails = !this.showSportDetails

                if (this.showSportDetails) {
                    this.$set(this, 'selectedSport', _.head(this.sports.filter(i => i.id == sport.id)))
                    $('html,body').animate({
                        scrollTop: $('.company-detail__header__practiced').offset().top - 80
                    }, 500)
                    if (this.showAllSports) {
                        this.toggleModalSports()
                    }
                } else {
                    this.$set(this, 'selectedSport', null)
                }

                let check = $('body').find('.modal-backdrop').length
                if (this.showSportDetails) {
                    if (! check) {
                        $('body').append('<div class="modal-backdrop fade show"></div>')
                    }
                } else {
                    $('.modal-backdrop').remove()
                }
            },
            toggleModalSports() {
                this.showAllSports = !this.showAllSports

                let check = $('body').find('.modal-backdrop').length
                if (this.showAllSports) {
                    if (! check) {
                        $('body').append('<div class="modal-backdrop fade show"></div>')
                    }
                } else {
                    $('.modal-backdrop').remove()
                }
            },
            loadMoreDesc() {
                this.descExpanded = !this.descExpanded
            },
            hasLogo() {
                if (this.company.original_logo_path) {
                    return this.company.original_logo_path;
                }
                if (this.images && typeof this.images[0] !== 'undefined') {
                    return this.images[0].file_path;
                }
                return this.company.logo_path;
            },
        },
        computed: {
            filled() {
                return !_.isEmpty(this.contact.email) && !_.isEmpty(this.contact.message)
            },
            os() {
                let ua = navigator.userAgent || navigator.vendor || window.opera
                if (/windows phone/i.test(ua)) {
                    return 'windows'
                }
                if (/android/i.test(ua)) {
                    return 'android'
                }1
                if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                    return 'ios'
                }
                return 'unknown'
            },
            calcDescription() {
                if (! _.isEmpty(this.company.description)) {
                    if (this.descExpanded)
                        return this.company.description;
                    return `${this.company.description.slice(0, this.limitDesc)}...`;
                }
            },
            isLoadMore() {
                if (!_.isEmpty(this.company.description)) {
                    return this.company.description.length > this.limitDesc
                }
                return false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/Detail.vue